/**
 * Palmesus brand tokens (Brand Guideline 2022).
 *
 * Palett:
 *  - Hovedfarge: #FF008C (magenta), sterkeste element, dominerer
 *  - Sekundærfarge: #FFD9EC (lys rosa)
 *  - Typo: fortrinnsvis negativ (hvit) eller svart
 *
 * Font: Gilmer (kommersiell). Vi bruker Poppins som nærmeste gratis
 * Google Font-erstatning. Geometrisk sans-serif med samme karakter.
 */

export const PALMESUS_COLORS = {
  pink: '#FF008C',         // Hovedfarge
  softPink: '#FFD9EC',     // Sekundærfarge
  white: '#FFFFFF',
  black: '#0A0A0A',
} as const;

/**
 * Gilmer er kommersiell, så vi bruker Poppins (geometrisk sans, samme karakter).
 * Last via Google Fonts i PalmesusLayout.
 */
export const PALMESUS_FONT = '"Poppins", "Gilmer", system-ui, -apple-system, "Segoe UI", sans-serif';

/**
 * Heading-letter-spacing per guideline: +10% mellom alle bokstaver.
 * I em-verdier ≈ 0.1em.
 */
export const PALMESUS_HEADING_TRACKING = '0.1em';

export const PALMESUS_INSTAGRAM_URL = 'https://www.instagram.com/palmesus/';

export interface PalmesusCampaign {
  slug: string;
  title: string;
  subtitle?: string;
  question?: string;
}

export const PALMESUS_CAMPAIGNS: Record<string, PalmesusCampaign> = {
  'palmesus-demo': {
    slug: 'palmesus-demo',
    title: 'Sangønsker',
    subtitle: 'Bystranda · 26–27 juni 2026',
    question: 'Hvilken sang vil du høre på Main Stage?',
  },
};

export function getPalmesusCampaign(slug: string | undefined): PalmesusCampaign | undefined {
  return slug ? PALMESUS_CAMPAIGNS[slug] : undefined;
}
